<footer class="footer-container">
    <div class="footer-wrapper">
        <!-- Footer Content -->
        <div class="footer-content">
            <!-- Coluna 1: Logo e Descrição -->
            <div class="footer-section footer-brand">
                <div class="footer-logo">
                    <img src="img/LogoFinal.png" alt="FluxoHost Logo">
                    
                </div>
                <p>Potencializando seu sucesso digital com soluções de hospedagem de alta performance, segurança e inovação constante para o seu negócio.</p>
                <div class="social-links">
                    <a href="https://www.facebook.com/fluxodigi" target="_blank" class="social-icon" title="Facebook">
                        <span uk-icon="icon: facebook; ratio: 0.8"></span>
                    </a>
                    <a href="https://www.youtube.com/@fluxodigital2485" target="_blank" class="social-icon" title="YouTube">
                        <span uk-icon="icon: youtube; ratio: 0.8"></span>
                    </a>
                    <a href="https://www.instagram.com/fluxodigital.oficial/" target="_blank" class="social-icon" title="Instagram">
                        <span uk-icon="icon: instagram; ratio: 0.8"></span>
                    </a>
                    <a href="https://wa.me/244937754502" target="_blank" class="social-icon" title="WhatsApp">
                        <span uk-icon="icon: whatsapp; ratio: 0.8"></span>
                    </a>
                </div>
            </div>

            <!-- Coluna 2: Links Rápidos -->
            <div class="footer-section">
                <h4>Links Rápidos</h4>
                <ul class="footer-links">
                    <li><a routerLink="/hosting">Hospedagem Web</a></li>
                    <li><a routerLink="/email-corporativo">Email Corporativo</a></li>
                    <li><a routerLink="/private-cloud">Private Cloud</a></li>
                    <li><a routerLink="/domain">Registro de Domínios</a></li>
                    <li><a routerLink="/produtos">Produtos</a></li>
                    <li><a routerLink="/servicos">Serviços</a></li>
                    <li><a routerLink="/sobre-nos">Sobre Nós</a></li>
                </ul>
            </div>

            <!-- Coluna 3: Suporte -->
            <div class="footer-section">
                <h4>Suporte</h4>
                <ul class="footer-links">
                    <li><a routerLink="/faq">Central de Ajuda</a></li>
                    <li><a target="_blank" href="https://youtube.com/playlist?list=PLSR5mDuFKRFPfLAwIPr-mUkGgq0QtnEoK">Tutoriais em Vídeo</a></li>
                    <li><a href="https://q28hpkmheelk.upmind.app/login" target="_blank">Área do Cliente</a></li>
                    <li><a href="mailto:suporte@fluxodigital.ao">Email de Suporte</a></li>
                </ul>
            </div>

            <!-- Coluna 4: Legal -->
            <div class="footer-section">
                <h4>Legal</h4>
                <ul class="footer-links">
                    <li><a routerLink="/termos-condicoes">Termos e Condições</a></li>
                    <li><a routerLink="/politicas">Política de Privacidade</a></li>
                    <li><a routerLink="/politica-de-cookies">Política de Cookies</a></li>
                </ul>
            </div>
        </div>

        <!-- Footer Bottom -->
        <div class="footer-bottom">
            <div class="footer-bottom-content">
                <p>&copy; 2026 <b>FLUXODIGITAL</b>. Todos os direitos reservados.</p>
            </div>
        </div>
    </div>
</footer>

